import axiosRetry from 'axios-retry';
import axios, { AxiosError, AxiosInstance, AxiosPromise, AxiosRequestConfig, AxiosResponse } from 'axios';
import { Toast } from 'antd-mobile/2x'
export interface IDataWithError<T> {
  data: T;
  code: number;
  msg: string;
}
class HttpService {
  private http!: AxiosInstance;
  constructor() {
    this.http = axios.create({
      baseURL: process.env.REACT_APP_JAVA_SASS,
      timeout: 60000,
    });
    axiosRetry(this.http, {
      retries: 3,
      shouldResetTimeout: true,
      // 重复请求延迟
      retryDelay: (retryCount: number) => {
        return retryCount * 1000;
      },
      retryCondition: (error: AxiosError) => {
        if (error.message.includes('timeout')) {
          return true;
        }
        return !error.response || error.response.status !== 401;
      },
    });

    this.addInterceptors(this.http);
  }

  get<T>(url: string, params?: any, config?: AxiosRequestConfig) {
    return this.handleErrorWrapper<T>(this.http.get(url, { ...config, params }));
  }

  post<T>(url: string, param: unknown, config?: AxiosRequestConfig) {
    return this.handleErrorWrapper<T>(this.http.post(url, param, config));
  }
  postDownload<T>(url: string, param: unknown) {
    return this.handleErrorWrapper<T>(this.http.post(url, param, { responseType: 'arraybuffer' }));
  }

  put<T>(url: string, param: unknown, config?: AxiosRequestConfig) {
    return this.handleErrorWrapper<T>(this.http.put(url, param, config));
  }

  delete<T>(url: string, param: unknown, config?: AxiosRequestConfig) {
    return this.handleErrorWrapper<T>(this.http.delete(url, { data: param, ...config }));
  }

  private addInterceptors(http: AxiosInstance) {
    // 一、请求拦截器
    http.interceptors.request.use((config: AxiosRequestConfig) => {
      config.baseURL = config.baseURL && config.baseURL
      config.headers = config.headers || {};
      if (config.method === "post" || config.method === "POST") {
        // config.headers["Content-Type"] = "application/json";
        // config.headers["Content-Type"] = "application/x-www-form-urlencoded;";
        // config.headers["Content-Type"] = "multipart/form-data";
      }
      // 1、添加token和项目Cookie
      config.headers["token"] = localStorage.getItem("mio-token") || "";
      config.headers["Authorization"] = localStorage.getItem("mio-token") || "";
      if (config.url&&!([
      '/mp2c-micro/user/miowelfare/login',
      '/mp2c-micro/user/certificate/page',
      '/mp2c-micro/quiz/v1/begin',
      '/mp2c-micro/quiz/v1/getQuestion',
      '/mp2c-micro/quiz/v1/submitOne',
      '/mp2c-micro/quiz/v1/getScore',
      '/mp2c-micro/quiz/v1/rankingList',
      '/mp2c-micro/quiz/v1/weekRankingList',
      '/mp2c-micro/quiz/v1/remind',
      '/mp2c-micro/quiz/v1/share/check',
      '/mp2c-micro/quiz/v1/giveup',
      '/mp2c-micro/quiz/v1/invitedStatus',
      '/mp2c-micro/quiz/v1/invitedByAnswer',
      '/mp2c-micro/quiz/v1/remind',
      '/mp2c-micro/quiz/v1/summary',
    ].includes(config.url))) {
        config.headers["b-token"] = localStorage.getItem("wel-token")?.replace(/"/g, '') || "";
      }
      // 2、验证请求状态码(错误范围)
      config.validateStatus = (status) => {
        console.warn(`status= ${status}`);
        return status >= 200 && status < 400;
      };
      return config;
    });

    // 二、响应拦截器
    http.interceptors.response.use(
      (response: AxiosResponse) => {
        return response.data;
      },
      (error) => {
        // 程序外错误
        return Promise.reject(error);
      },
    );
  }

  private async handleErrorWrapper<T>(p: AxiosPromise): Promise<T> {
    return p
      .then((response: any) => {
        switch (response.code) {
          case 200:
            return response.data as T;;
          case "success":
            return response.data as T;;
          case 10001:
            Toast.show({ content: response?.message })
            return "" as unknown as T;;
          case 20201:
            console.log(response?.message)
            Toast.show({ content: response?.message })
            return "" as unknown as T;;
          default:
            Toast.show({ content: response?.message })
            return undefined as unknown as T;;
        }
      })
  }
}

export const httpService = new HttpService();